var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card-content",
    [
      _c("w-input", {
        attrs: { fancy: "", label: _vm.$ct("labels.contact") },
        model: {
          value: _vm.value.Props.Contact,
          callback: function ($$v) {
            _vm.$set(_vm.value.Props, "Contact", $$v)
          },
          expression: "value.Props.Contact",
        },
      }),
      _c("w-select", {
        staticClass: "mt",
        attrs: {
          value: _vm.phoneSource,
          items: _vm.phoneSourceItems,
          fancy: "",
          label: _vm.$ct("labels.phone"),
        },
        on: {
          input: function ($event) {
            return _vm.setPhoneSource($event)
          },
        },
      }),
      _vm.phoneSource == "other"
        ? _c(
            "div",
            { staticClass: "phone-other mt" },
            [
              _c("w-input", {
                attrs: { fancy: "", label: _vm.$ct("labels.phone") },
                model: {
                  value: _vm.value.Props.Phone,
                  callback: function ($$v) {
                    _vm.$set(_vm.value.Props, "Phone", $$v)
                  },
                  expression: "value.Props.Phone",
                },
              }),
              _vm.canSavePhone
                ? _c(
                    "w-dropdown",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.$ct("labels.save-phone"),
                          expression: "$ct('labels.save-phone')",
                        },
                      ],
                      staticClass: "mls",
                      attrs: {
                        items: _vm.savePhoneItems,
                        disabled: _vm.savingPhone,
                        light: "",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.savePhone($event)
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "save" } })],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _c("w-editor", {
        staticClass: "mt",
        attrs: {
          value: _vm.text,
          fancy: "",
          label: _vm.$ct("labels.description"),
          height: "200",
        },
        on: {
          input: function ($event) {
            return _vm.onInput($event)
          },
          "cursor-position": function ($event) {
            return _vm.$emit("cursor-position", $event)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }